const getById = (state, action) => {
    return Object.assign(Object.assign({}, state), { [action.payload.id]: Object.assign(Object.assign({}, state[action.payload.id]), { progress: action.payload.progress }) });
};
const getAllIds = (state, action) => {
    const { id } = action.payload;
    let newState = [...state];
    if (!state.includes(id)) {
        newState = state.concat(id);
    }
    return newState;
};
export function singleFileUploadProgressReducer(state, action) {
    return Object.assign(Object.assign({}, state), { byId: getById(state.byId, action), allIds: getAllIds(state.allIds, action) });
}
//# sourceMappingURL=singleFileUploadProgressReducer.js.map